import React, {useState} from 'react';
import {Link} from "react-router-dom";

import '../styles/readyToBegin.css'
import {ProgramType} from "../GlobalTypes";

interface ReadyToBeginProps {
  programType: ProgramType
}

const ReadyToBegin = (props: ReadyToBeginProps) => {
  const {programType} = props;
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const handlePopup = () => setShowPopup(!showPopup);

  const EligibilityRequirements = () => {
    return (
      <div className="eligibility-popup-content">
        <div className="eligibility-popup-close" onClick={handlePopup}>&times;</div>
        <div className="eligibility-popup-text">
          <br/><br/>
          <h5>Who is eligible for the Link Local Program?</h5>
          <ul>
            <li><p>NYC small business with less than 50 employees</p></li>
            <li><p>NYC small business with less than 3 brick and mortar locations</p></li>
            <li><p>Small online businesses based in NYC</p></li>
            <li><p>Non-profit organizations based in NYC</p></li>
            <li><p>Community organizations</p></li>
            <li><p>Schools, summer camps and museums</p></li>
          </ul>
          <h5>
            Link Local businesses, events and services<br/>
            <u>must</u> be located in New York City.</h5>
        </div>
      </div>
    );
  }

  const DefaultReadyToBegin = () => {
    const contentCreatorRoute = programType === ProgramType.Basic
      ? "/I1qRlWdvvBN2Zg5AkS74dhHHqQgI3iiULpVasUCmsLl4EAt7YZ/basic-content-creator"
      : "/I1qRlWdvvBN2Zg5AkS74dhHHqQgI3iiULpVasUCmsLl4EAt7YZ/plus-content-creator";

    return (
      <>
        <h3 className={"first-section"}>
          Ready to begin your Link Local<br/>or Link Local Plus application?
        </h3>
        <p className={"second-section"}>
          Please review our
          <button onClick={handlePopup}><span>eligibility requirements</span></button>
          before continuing.
        </p>
        <div className={"third-section"}>
          <p className={"first"}>
            Is your business located within one of the 5 boroughs?
          </p>
          <p className={"second"}>
            (Bronx, Brooklyn, Manhattan, Queens, Staten Island)
          </p>

          <div className={"rtb-button contact-email"}>
            <a href="/I1qRlWdvvBN2Zg5AkS74dhHHqQgI3iiULpVasUCmsLl4EAt7YZ/local-information.html">No</a>
            <Link to={contentCreatorRoute}>Yes</Link>
          </div>
        </div>
      </>
    )
  }
  const showEligibility = showPopup ? <EligibilityRequirements/> : <DefaultReadyToBegin/>;

  return (
    <div className={"rtb-main"}>
      {showEligibility}
    </div>
  )
};

export default ReadyToBegin;
